module.exports = __webpack_public_path__ + "img/otp.96433888.png";